import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Router } from "@angular/router";

@Component({
  selector: 'app-private',
  templateUrl: './private.component.html',
  styleUrls: ['./private.component.css']
})
export class PrivateComponent implements OnInit {
  route: string;
  currentTab = null;
  constructor(location: Location, router: Router) {
    router.events.subscribe(val => {
      if (location.path().includes('/sales')){
        this.currentTab = location.path().split('/sales/')[1];
      }else{
        this.currentTab = null;
      }
    });
  }


  ngOnInit() {
    
  }

}
